import { AssetTerm } from "@models/asset/asset-term";
import { createAction, props } from "@ngrx/store";

export default {
  termAssetLoading: createAction("[Term Asset] loading"),
  termAssetLoaded: createAction("[Term Asset] Term Asset loaded successfully", props<{ assetTerm: AssetTerm }>()),
  reset: createAction("[Term Asset] reseted"),
  error: createAction("[Term Asset] error", props<{ error: string }>())
};
